exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".exportTypeSelector{width:70%;margin-left:15%}.exportTypeSelector .buttonContainer{display:flex;justify-content:center;margin-bottom:1em}.exportTypeSelector .buttonContainer button{flex:1}.exportTypeSelector .buttonContainer .pdfBtn{background-color:#00a0f4;margin-right:1em}.exportTypeSelector .buttonContainer .pdfBtn,.exportTypeSelector .buttonContainer .xslBtn{margin-top:10px;color:#fff;border-radius:5px;border:none;padding:10px 20px;font-size:16px;font-weight:700;box-shadow:0 4px 4px 0 rgba(0,0,0,.2);margin-top:.8em}.exportTypeSelector .buttonContainer .xslBtn{background-color:#42af14;margin-left:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/exports/export_type_selector.scss
// module id = 1270
// module chunks = 0